import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDroppable } from "@dnd-kit/core";
import { useTrackDnd } from "./TrackDndProvider";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    minHeight: 200,
    paddingBottom: theme.spacing(10), // matches previous 80px
    transition: (props) => props.isDragInProgress ? "none" : "all 0.2s ease",
    border: "1px solid transparent",
    borderRadius: theme.spacing(1),
    margin: theme.spacing(0.25),
    boxShadow: "none",
    backgroundColor: "transparent",
  },
  dragActive: {
    border: `2px dashed ${theme.palette.divider}`,
  },
  dragOver: {
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.08)",
    borderColor: theme.palette.primary.main,
    boxShadow: theme.shadows[2],
  },
  dropHint: {
    position: "absolute",
    bottom: 10,
    left: "50%",
    transform: "translateX(-50%)",
    opacity: 0.5,
    pointerEvents: "none",
    fontSize: "0.7rem",
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
  },
}));

/**
 * Shared droppable track container component for @dnd-kit.
 * Handles drop zone detection and visual feedback.
 */
export const DroppableTrack = ({ trackLocationId, children, className, id: idOverride }) => {
  const { activeItem } = useTrackDnd();
  const isDragInProgress = !!activeItem;
  const classes = useStyles({ isDragInProgress });
  
  // Standardize ID generation: track-[id] or track-empty
  const droppableId = idOverride || (trackLocationId ? `track-${trackLocationId}` : 'track-empty');
  
  const { setNodeRef, isOver } = useDroppable({
    id: droppableId,
  });

  return (
    <div
      ref={setNodeRef}
      className={clsx(
        classes.root,
        className,
        isDragInProgress && classes.dragActive,
        isOver && classes.dragOver
      )}
      data-track-id={trackLocationId}
      id={droppableId}
    >
      {children}
      {isDragInProgress && !isOver && (
        <div className={classes.dropHint}>
          Drop here
        </div>
      )}
    </div>
  );
};

